import { createRouter, createWebHistory } from 'vue-router'
import HomePage from '../pages/HomePage'
import MissionPage from '../pages/MissionPage'
import ServiceDetailsPage from '../pages/ServiceDetailsPage'
import PrivacyPage from '../pages/PrivacyPage.vue'
import TermsPage from '../pages/TermsPage.vue'
import PaymentPlansPage from '../pages/PaymentPlansPage.vue'
import MedicationInfoPage from '../pages/MedicationInfoPage.vue'
import TelehealthServicesPage from '../pages/TelehealthServicesPage.vue'

const WeightLossPage = () => import('../pages/WeightLoss/WeightLossPage.vue')

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomePage
  },
  {
    path: '/mission',
    name: 'Mission',
    component: MissionPage
  },
  {
    path: '/privacy',
    name: 'Privacy Policy',
    component: PrivacyPage
  },
  {
    path: '/terms',
    name: 'Terms and Conditions',
    component: TermsPage
  },
  {
    path: '/payment-plans',
    name: 'Payment Plans',
    component: PaymentPlansPage
  },
  {
    path: '/medication-information',
    name: 'Medication Information',
    component: MedicationInfoPage
  },
  {
    path: '/telehealth-services',
    name: 'Telehealth Services',
    component: TelehealthServicesPage
  },
  {
    path: '/medical-weight-loss-program-doctor-supervised-treatments',
    name: 'WeightLoss',
    component: WeightLossPage,
    meta: { standalone: true }
  },
  {
    path: '/service/weight-loss-non-surgical-fat-reduction',
    redirect: '/medical-weight-loss-program-doctor-supervised-treatments'
  },
  {
    path: '/service/:service?',
    name: 'Service',
    component: ServiceDetailsPage,
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    // always scroll to top
    return { top: 0 }
  },
})

export default router